import apiClient from '../../core/apiClient';
import { endpoints } from '../../core/endpoints';
import type { Role, CreateRoleDto, UpdateRoleDto } from './roles.types';

const BASE = endpoints.auth.roles;

export const getRoles = (params?: { search?: string }, signal?: AbortSignal): Promise<Role[]> =>
  apiClient.get<Role[]>(BASE, params, { signal });

export const createRole = (data: CreateRoleDto): Promise<Role> =>
  apiClient.post<Role>(BASE, data);

export const updateRole = (id: string, data: UpdateRoleDto): Promise<Role> =>
  apiClient.put<Role>(`${BASE}/${id}`, data);

export const deleteRole = (id: string): Promise<void> =>
  apiClient.delete<void>(`${BASE}/${id}`);
